import axios from '@/plugins/axios';
import { Response } from '@/types/common/Rest';
import { VUE_APP_GCN_SERVICES } from '@/constants';
import { handleApiResponse } from '@/utils/request';
import { IFiltroBoletins, PageBoletins } from '../types';

const BASE_URL = `${VUE_APP_GCN_SERVICES}/publico/boletim`;

class BoletinsService {
  public async consultarBoletins(
    filtro: IFiltroBoletins
  ): Promise<Response<PageBoletins>> {
    const url = `${BASE_URL}/find/boletins`;
    return handleApiResponse(() => axios.post(url, filtro));
  }

  public async downloadBoletimComDocumento(
    codigosDocumentos: Array<number | undefined>
  ) {
    const url = `${BASE_URL}/buscar/documentos`;
    const { data } = await axios.post(
      url,
      { cdDocumentos: codigosDocumentos },
      {
        responseType: 'blob',
      }
    );
    return data;
  }

  public downloadBoletimSemDocumento(
    codigosDocumentos: Array<number | undefined>
  ) {
    const urlRelatorio = `${window.location.origin}/mat-report/publico/gcn/api/v1.0/boletim?boletins=${codigosDocumentos}`;
    window.open(`${urlRelatorio}&formato=S`, '_blank');
  }
}

export default new BoletinsService();
